import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SellerResponse } from '../models/seller.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SellerService {
  private readonly API_URL = '/sellers';
  private apiService = inject(ApiService);


  getSellerByCode(code: string): Observable<SellerResponse> {
    return this.apiService.get<SellerResponse>(
      `${this.API_URL}/by-code/${code}`
    );
  } 
}
